module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-info-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.isLoaded ? 'Кратко ' : 'Еще ',
      "expandable": (!_vm.isLoaded && this.lastItems.length > 0) || (this.topCount <= this.lastItems.length && this.lastItems.length > 0)
    },
    on: {
      "click": function($event) {
        return _vm.switchTitle()
      }
    }
  }, [_vm._l((_vm.topItems), function(item) {
    return [_c('v-layout', {
      attrs: {
        "column": ""
      }
    }, [_c('v-flex', [_vm._v("\n           Номер сводного исполнительного производства: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.totalNumber)))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n           Номер исполнительного производства: "), _c('b', [_vm._v(_vm._s(item.enforcementNumber))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n            Задолженность по документу: " + _vm._s(_vm.formats.blank(item.amount, this.formatCurrency)) + "\n          ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n            Остаток задолженности: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.remaining, this.formatCurrency)))])]), _vm._v(" "), _c('v-flex', [_c('b', [_vm._v(_vm._s(item.executionObject))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n            Исполнительный документ:\n            "), (item.document) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v(_vm._s(item.document.type))]), _vm._v(" "), _c('div', [_vm._v("\n              Номер "), _c('b', [_vm._v(_vm._s(item.document.number))]), _vm._v(" от "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.document.date, _vm.formats.formatDate)))])])]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', [_vm._v("\n            Взыскатель:\n            "), (item.collector && !item.collectorRef) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("ИНН:"), _c('b', [_vm._v(_vm._s(_vm.formats.formatInn(item.collector)))])]) : _vm._e(), _vm._v(" "), (item.collectorRef) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatReference(item.collectorRef))
      }
    }), _vm._v(" "), _c(_vm.renderFlags(item.collectorRef.flags, true), {
      tag: "v-component"
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', [_vm._v("\n            Должник:\n            "), (item.debtorRef) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatReference(item.debtorRef))
      }
    }), _vm._v(" "), _c(_vm.renderFlags(item.debtorRef.flags, true), {
      tag: "v-component"
    })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("По ФССП:")]), _vm._v(" "), (item.debtor) ? _c('v-flex', {
      attrs: {
        "pl-3": ""
      }
    }, [_vm._v(_vm._s(item.debtorName) + " (" + _vm._s(item.debtor) + ")")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-3": ""
      }
    }, [_vm._v("\n              Адрес: " + _vm._s(item.debtorAddress) + "\n            ")])], 1), _vm._v(" "), _c('v-flex', [_vm._v("\n            Дело в производстве в:\n            "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v(_vm._s(item.department))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n             Адрес "), _c('b', [_vm._v(_vm._s(item.departmentAddress))])])], 1), _vm._v(" "), _c('v-flex', [_vm._v("\n            Актуальность с "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.fileDate, _vm.formats.formatDate)))]), _vm._v(" по " + _vm._s(_vm.formats.blank(item.lastDate, _vm.formats.formatDate)) + "\n          ")])], 1)]
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pt-2": ""
    }
  }, [_vm._v(" История изменений: ")]), _vm._v(" "), (_vm.isLoaded && this.lastItems.length === 0) ? _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_vm._v("Нет данных")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lastItems), function(item) {
    return [_c('v-flex', {
      attrs: {
        "pl-2": "",
        "pb-2": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "column": ""
      }
    }, [(_vm.isInDiff(item, 'totalNumber')) ? _c('v-flex', [_vm._v("\n               Номер сводного исполнительного.производства: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.totalNumber)))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'enforcementNumber')) ? _c('v-flex', [_vm._v("\n               Номер исполнительного производства: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.enforcementNumber)))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'stage')) ? _c('v-flex', [_vm._v("\n               Статус: "), _c('b', [_vm._v(_vm._s(item.stage ? (item.stage == 1 ? 'Открыто' : 'Закрыто') : '-'))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'amount')) ? _c('v-flex', [_vm._v("\n                Задолженность по документу: " + _vm._s(_vm.formats.blank(item.amount, this.formatCurrency)) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'remaining')) ? _c('v-flex', [_vm._v("\n                Остаток задолженности: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.remaining, this.formatCurrency)))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'executionObject')) ? _c('v-flex', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.executionObject)))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'document')) ? _c('v-flex', [_vm._v("\n                Исп. документ: "), (item.document) ? _c('span', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("-")]) : _vm._e(), _vm._v(" "), (item.document) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.document.type)))]), _vm._v(" "), _c('div', [_vm._v("\n                  Номер "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.document.number)))]), _vm._v(" от "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.document.date, _vm.formats.formatDate)))])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'collector')) ? _c('v-flex', [_vm._v("\n                Взыскатель:\n                "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v("ИНН: " + _vm._s(_vm.formats.blank(_vm.formats.formatInn(item.collector))))])])], 1) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'debtor') || _vm.isInDiff(item, 'debtorName') || _vm.isInDiff(item, 'debtorAddress')) ? _c('v-flex', [_vm._v("\n                Должник:\n                "), (_vm.isInDiff(item, 'debtor')) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n                  ИНН:"), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.formats.formatInn(item.debtor))))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'debtorName')) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n                  Название"), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.debtorName)))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'debtorAddress')) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n                  Адрес: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.debtorAddress)))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'department') || _vm.isInDiff(item, 'departmentAddress')) ? _c('v-flex', [_vm._v("\n                Дело в производстве в:\n                "), (_vm.isInDiff(item, 'departmentAddress')) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.department)))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'departmentAddress')) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n                 Адрес "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.departmentAddress)))])]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pb-0": "",
        "align-end": ""
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.fileDate, _vm.formats.formatDate)))])], 1)], 1)]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-641a081b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/EnforcementForm.vue
// module id = 1053
// module chunks = 1